// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Default style for the box */
.centered-box {
    display: flex;
    position: fixed;

    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    padding: 3vw;
    border-radius: 30px;
    z-index: 3;

    max-width: 50vw;
    max-height: 70vh;
}

.visible {
    background-color: white;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}

.invisible {
    background-color: transparent;
}

.blur-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.5);
    -webkit-backdrop-filter: blur(8px);
            backdrop-filter: blur(8px);
    z-index: 2;
}

.center-box-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-items: center;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 2vw;
}

.center-box-input {
    display: flex;
    align-self: center;
    justify-self: center;
    margin-top: 5px;
    margin-bottom: 5px;
}

.center-box-buttons {
    display: flex;
    justify-self: flex-end;
    align-self: flex-end;
    flex-direction: row;
    margin-top: 5px;
    margin-bottom: 5px;
}

.center-box-text {
    align-self: self-start;
    justify-self: self-start;
    margin-top: 5px;
    margin-bottom: 5px;
}

.center-box-invisible-title {
    height: auto;
    display: flex;
    align-self: center;
    justify-self: center;
    text-align: center;
    margin-top: 5px;
    margin-bottom: 5px;
}

.center-box-invisible-text {
    height: auto;
    display: flex;
    align-self: center;
    justify-self: center;
    text-align: center;
    margin-top: 5px;
    margin-bottom: 5px;
}`, "",{"version":3,"sources":["webpack://./src/themes/components/layout/center-box.styles.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;IACI,aAAa;IACb,eAAe;;IAEf,QAAQ;IACR,SAAS;IACT,gCAAgC;;IAEhC,YAAY;IACZ,mBAAmB;IACnB,UAAU;;IAEV,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,uCAAuC;AAC3C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,kCAA0B;YAA1B,0BAA0B;IAC1B,UAAU;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,wBAAwB;IACxB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;AACtB","sourcesContent":["/* Default style for the box */\n.centered-box {\n    display: flex;\n    position: fixed;\n\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n\n    padding: 3vw;\n    border-radius: 30px;\n    z-index: 3;\n\n    max-width: 50vw;\n    max-height: 70vh;\n}\n\n.visible {\n    background-color: white;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\n}\n\n.invisible {\n    background-color: transparent;\n}\n\n.blur-backdrop {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(255, 255, 255, 0.5);\n    backdrop-filter: blur(8px);\n    z-index: 2;\n}\n\n.center-box-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-items: center;\n    overflow-y: auto;\n    overflow-x: hidden;\n    padding: 2vw;\n}\n\n.center-box-input {\n    display: flex;\n    align-self: center;\n    justify-self: center;\n    margin-top: 5px;\n    margin-bottom: 5px;\n}\n\n.center-box-buttons {\n    display: flex;\n    justify-self: flex-end;\n    align-self: flex-end;\n    flex-direction: row;\n    margin-top: 5px;\n    margin-bottom: 5px;\n}\n\n.center-box-text {\n    align-self: self-start;\n    justify-self: self-start;\n    margin-top: 5px;\n    margin-bottom: 5px;\n}\n\n.center-box-invisible-title {\n    height: auto;\n    display: flex;\n    align-self: center;\n    justify-self: center;\n    text-align: center;\n    margin-top: 5px;\n    margin-bottom: 5px;\n}\n\n.center-box-invisible-text {\n    height: auto;\n    display: flex;\n    align-self: center;\n    justify-self: center;\n    text-align: center;\n    margin-top: 5px;\n    margin-bottom: 5px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
